// ============================================================================
// Everything we hold about one booking, opened by clicking its row on the
// Logistics dashboard. The table keeps only the columns ops scans across (who /
// where / status); the long tail lives here, so nobody has to drag the table
// sideways to read the middle of a row.
//
// The body is the shared <BookingDetails> — the same rendering the OMS order
// page shows for a leg — so the two can't drift apart.
// ============================================================================
import { Button, Drawer, Space } from "antd";
import React from "react";
import BookingDetails, { fromRow } from "../../components/booking_details";
import { LogisticsOrderRow } from "../../types";

interface Props {
  booking: LogisticsOrderRow | null;
  onClose: () => void;
  onEdit: (row: LogisticsOrderRow) => void;
  onReassign: (row: LogisticsOrderRow) => void;
}

const BookingDrawer: React.FC<Props> = ({ booking, onClose, onEdit, onReassign }) => (
  <Drawer
    title={booking ? `Booking #${booking.id}` : "Booking"}
    placement="right"
    width={520}
    open={!!booking}
    onClose={onClose}
    extra={
      booking && (
        <Space>
          <Button size="small" onClick={() => onEdit(booking)}>
            Edit details
          </Button>
          {booking.is_active && (
            <Button size="small" onClick={() => onReassign(booking)}>
              Move carrier
            </Button>
          )}
        </Space>
      )
    }
  >
    {booking && <BookingDetails view={fromRow(booking)} />}
  </Drawer>
);

export default BookingDrawer;
